import {
  USAGE_DEFINITION,
  UNIQUE_USER_USAGE_DEFINITION,
  PERFORMANCE_DEFINITION,
  UNIQUE_USER_PERFORMANCE_DEFINITION,
} from "@/misc/desktopCharts";
import { RATE_ERROR_CHARTS } from "@/misc/filterErrorCharts";
import { getDataByStartAndEndDate } from "./lib/callChartAPI";
import normalizeFiltersForAPI from "@/lib/normalizeFilters";
import hasProductFilterError from "@/lib/hasProductFilterError";

const getChartDefinition = (showOnlyUniqueUsers, page, view) => {
  if (page === "usage") {
    return showOnlyUniqueUsers ? UNIQUE_USER_USAGE_DEFINITION : USAGE_DEFINITION;
  }

  const chartDefinition = showOnlyUniqueUsers ? UNIQUE_USER_PERFORMANCE_DEFINITION : PERFORMANCE_DEFINITION;
  return chartDefinition.find((def) => def.name === view).content;
};

export default async (payload) => {
  const { view, name, storeId, startDate, endDate, filters, showOnlyUniqueUsers, page } = payload;
  const chartDefinition = getChartDefinition(showOnlyUniqueUsers, page, view);
  const targetChartInfo = chartDefinition.find((def) => def.name === name);
  const isFilterErrorChart = hasProductFilterError(targetChartInfo, filters, showOnlyUniqueUsers);

  const errorReturnObject = {
    rateTotal: "n/a",
    valueTotal: "n/a",
    rateData: { isError: true },
    valueData: { isError: true },
    showResetFiltersButton: true,
  };

  if (isFilterErrorChart) return errorReturnObject;

  const normalizedFilters = normalizeFiltersForAPI(filters);
  const responses = await Promise.all([
    getDataByStartAndEndDate(targetChartInfo.rateChartName, startDate, endDate, storeId, normalizedFilters),
    getDataByStartAndEndDate(targetChartInfo.valueChartName, startDate, endDate, storeId, normalizedFilters),
  ]);

  const rateTotalDataIsWrong = RATE_ERROR_CHARTS.includes(targetChartInfo.rateChartName) && responses[0].total > 3;
  if (rateTotalDataIsWrong) {
    errorReturnObject.showResetFiltersButton = false;
    return errorReturnObject;
  }

  return {
    rateTotal: responses[0].total || "n/a",
    valueTotal: responses[1].total || "n/a",
    rateData: responses[0].data,
    valueData: responses[1].data,
  };
};
